import { useEffect } from "react";
import { useSelector } from "react-redux";

import { convertSecondsToHHMMSS } from "../Components/NewDashboard/Commons/utils";

const useTimeTrackingTitle = () => {
  const { elapsedTime } = useSelector((state) => state.timeTracking);

  useEffect(() => {
    if (!elapsedTime) return;
    document.title =
      convertSecondsToHHMMSS(elapsedTime).formattedTime +
      " • Zodot | Time Tracking";

    return () => (document.title = "Zodot");
  }, [elapsedTime]);
};

export default useTimeTrackingTitle;
